import React from 'react';
import styled from 'styled-components';
import logo from "./images/logo2.png"
import {Button} from "./styles/Button";
import { NavLink } from 'react-router-dom';
import { useState } from 'react';
import Axios from 'axios';

const Register = () => {
  const [userNameReg, setUsernameReg] = useState('');
  const [dob, setDob] = useState();
  const [branch, setBranch] = useState();
  const [year, setYear] = useState();
  const [rollNo, setrollNo] = useState('');
 
   
    const display = () => {
      Axios.post('http://localhost:5000/create' , {name: userNameReg, dob: dob , branch: branch
    , year: year, rollNo: rollNo}).then(()=> {console.log("sucess")});
     
    }
  return (
    <Wrapper>
        <div className='main_div'>
            <div className='child_div'>
                <NavLink to ="/" >
                   <img src={logo} alt = 'logo' className='logo'/>
                 </NavLink>
                 <div className = "form_elements">
                 <div><label>Enter your Name:</label><input type="text" placeholder="Enter Your Name" value = {userNameReg} onChange={(e) =>{ setUsernameReg(e.target.value) }} /></div>
                 <div><label>Enter Your DOB:</label><input type="date" placeholder="Enter your DOB" value = {dob} onChange={(e) =>{ setDob(e.target.value) }}/></div>
                 <div>
                 <label>Select Your Branch :</label>
                 <select value = {branch} onChange={(e) =>{ setBranch(e.target.value) }}>
                    <option>Select</option>
                    <option>Information Technology</option>
                    <option>Computer Science</option>
                    <option>Mechanical Enginnering</option>
                    <option>Chemical Enginnering</option>
                    <option>Electronics Enginnering</option>
                    <option>Civil Enginnering</option>
                    <option>Paint Technology</option>
                    <option>Oil Technology</option>
                    <option>Food Technology</option>
                    <option>Electrical Technology</option>
                    <option>Leather Technology</option>
                 </select></div>
                 <div>
                 <label>Select Your Year :</label>
                 <select value = {year} onChange={(e) =>{ setYear(e.target.value) }}>
                    <option>Select</option>
                    <option>First Year</option>
                    <option>Second Year</option>
                    <option>Third Year</option>
                    <option>Final Year</option>
                    
                 </select></div><div>
                 <label>Enter Roll No :</label>
                 <input type="text" placeholder="Enter your Roll No" value = {rollNo} onChange={(e) =>{ setrollNo(e.target.value) }}/></div>
                 </div>
                 <Button onClick={() => display()}>Register</Button> <p>Already have an account? <NavLink to="/login"> Login</NavLink></p>
            </div>
        </div>
    </Wrapper>
  )
}
const Wrapper = styled.section`
    
.main_div{
    height: 100vh;
    width: 100vw;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

}

.child_div{
    height: 80vh;
    width: 90vw;
    background-color: rgb(249 249 255);
    padding: 4rem;
    ${'' /* display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center; */}

}

input,  select{
  width: 25rem;
  height: 4.8rem;
  margin: 2.5rem 3.5rem;
  border: 0.3px solid rgb(255, 255, 255);
  border-radius: 0.4rem;
}
label{
    font-size: 1.8rem;
}
img{

    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 8%;
}
.form_elements{
  margin-top: 5%;
  display: grid;
  ${'' /* grid-template-rows: 2fr 2fr; */}
  grid-template-columns: auto auto auto;
}

input, select{
   margin-left: 0px;
}
`;

export default Register